import { isApp } from './env'
import { Cookie } from './cookie'
import { Observer } from './rx'

interface IShare {
    title: string
    content: string
    image: string
    url: string
}

class NativeInject {
    public static init() {
        if (isApp()) {
            if (window.WebViewJavascriptBridge) {
                return this.injectSuccess(window.WebViewJavascriptBridge)
            }
            if (window.WVJBCallbacks) {
                return window.WVJBCallbacks.push((bridge: any) => {
                    this.injectSuccess(bridge)
                })
            }
            window.WVJBCallbacks = [
                (bridge: any) => {
                    this.injectSuccess(bridge)
                }
            ]
            const WVJBIframe: HTMLIFrameElement = document.createElement('iframe')
            WVJBIframe.style.display = 'none'
            WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
            document.documentElement.appendChild(WVJBIframe)
            setTimeout(() => {
                document.documentElement.removeChild(WVJBIframe)
            }, 0)
        }
    }

    private static injectSuccess(bridge: any) {
        // 向app提供可调用函数
        defaultAppFn.h5.init(bridge)
        defaultAppFn.Apply('app_loginStatus', null, (data: any) => {
            Cookie.set(data.token)
        })
    }
}

class AppConfig {
    public h5: H5Funcs = new H5Funcs()
    private app: AppFuncs = new AppFuncs()

    constructor() {
        this.init()
    }

    public Apply(name: string, data?: any, cb?: any) {
        if (isApp()) {
            this.app.apply(name, data, cb)
        }
    }

    private init() {
        this.app.push([
            {
                // 关闭hybird
                name: 'app_hybridClose',
                data: null,
                fn: () => {
                    // empty
                }
            },
            {
                // 关闭hybird
                name: 'app_showShareBtn',
                data: {
                    show: true
                },
                fn: () => {
                    // empty
                }
            },
            {
                // 获取用户信息
                name: 'app_loginStatus',
                data: null,
                fn: () => {
                    // empty
                }
            },
            {
                // 调用登陆功能
                name: 'app_login',
                data: null,
                fn: () => {
                    // empty
                }
            },
            {
                // 分享功能
                name: 'app_share',
                data: {
                    title: '',
                    content: '',
                    image: '',
                    url: ''
                },
                fn: () => {
                    // empty
                }
            },
            {
                // 这是导航
                name: 'app_nav',
                data: {
                    show: true,         // nav状态栏默认显示，除非主动调用该函数关闭
                    back: true,         // nav状态栏回退按钮是否显示，默认显示
                    title: '有色投票',   // nav状态栏标题
                    share: false        // nav状态栏分享按钮是否显示，分享按钮默认不显示
                },
                fn: () => {
                    // empty
                }
            },
            {
                // 新开页面webview
                name: 'app_protocol',
                data: {
                    protocol: ''
                },
                fn: () => {
                    // empty
                }
            },
            {
                // 统计事件
                name: 'app_ga_event',
                data: {
                    category: '',
                    action: '',
                    label: '',
                    value: 0
                },
                fn: () => {
                    // empty
                }
            },
            {
                // 统计页面
                name: 'app_ga_screen',
                data: {
                    name: ''
                },
                fn: () => {
                    // empty
                }
            }
        ])

        this.h5.push([
            {
                // app 登录成功的回调
                name: 'h5_login',
                fn: (data) => {
                    Cookie.set(data.token)
                    window.location.reload()
                }
            },
            {
                // app 后退的回调
                name: 'h5_goBack',
                fn: () => {
                    // empty
                }
            },
            {
                // 分享
                name: 'h5_share',
                fn: () => {
                    // empty
                    Observer.send('share')
                }
            }
        ])
    }
}

// 回调函数
type ICallBackFn = (data: any, cb: () => void) => any

// app API结构
interface IH5API {
    name: string
    fn: ICallBackFn
}

// 索引App提供功能
interface IAPPAPI {
    name: string
    data: any
    fn(res: any): any
}

class Status {
    private currentStatus: boolean = false // 是否是可用状态

    get status(): boolean {
        return this.currentStatus
    }

    set status(status: boolean) {
        this.currentStatus = status
    }
}

class AppFuncs extends Status {
    private data = new Map<string, IAPPAPI>()

    public apply(name: string, data?: any, cb?: any) {
        const fn = this.data.get(name)
        if (fn) {
            cb = cb ? cb : fn.fn
            data = data ? data : fn.data
            window.WebViewJavascriptBridge.callHandler(name, data, cb)
        }
    }

    public push(item: IAPPAPI[] | IAPPAPI) {
        if (item instanceof Array) {
            for (const v of item as IAPPAPI[]) {
                this.data.set(v.name, v)
            }
        } else {
            this.data.set(item.name, item)
        }
    }
}

class H5Funcs extends Status {
    private data: IH5API[] = []

    public init(bridge: any) {
        this.data.forEach(item => {
            bridge.registerHandler(item.name, item.fn)
        })
    }

    public push(data: IH5API[] | IH5API) {
        if (data instanceof Array) {
            for (const v of data as IH5API[]) {
                this.data.push(v)
            }
        } else {
            this.data.push(data)
        }
    }
}

const defaultAppFn = new AppConfig()

export {
    NativeInject,
    defaultAppFn,
    IShare
}


// WEBPACK FOOTER //
// ./src/utils/app.ts